export default __webpack_public_path__ + "static/media/Artboard 6.bf464c3b.png";